import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ReserveForApr extends React.Component
{
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    return (
      <div>
        <a href="https://www.nsru.ac.th/pr/" target="_blank">
          <img
            src="https://www.nsru.ac.th/admin/storage/banners/November2023/jvwje6qSD2RuHXvnsgIR.jpg"
            className="img-responsive mb-2 rounded"
            alt="สมัครเรียนต่อ มหาวิทยาลัยราชภัฏนครสวรรค์ : nsru dek67"
          />
        </a>
      </div>
    );
  }
}

export default ReserveForApr;
